import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnnualDetailsModule } from '../../Annual-Details/annual-details.module';
import { AttachmentModule } from '../../Attachment/attachment.module';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { ParcelIconModule } from '../../Entity/Parcel/Icon/parcelIcon.module';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { QuickSearchCriteriaModule } from '../../Search/Quick/Criteria/quickSearchCriteria.module';
import { QuickSearchModule } from '../../Search/Quick/quickSearch.module';
import { UILibModule } from '../../UI-Lib/UILib.module';
import { DocumentProcessingComponent } from './documentProcessing.component';
import { EntityEditComponent } from './Entity-Edit/entity-edit.component';
import { IdpDetailCardComponent } from './Entity-Edit/IDP/Detail-Modal/Card/idpDetailCard.component';
import { IdpBillDetailModalComponent } from './Entity-Edit/IDP/Detail-Modal/idpBillDetailModal.component';
import { IdpConfidenceDetailsComponent } from './Entity-Edit/IDP/idpConfidenceDetails.component';
import { EntityPanelComponent } from './Entity-Panel/entityPanel.component';
import { DocumentProcessingExceptionModalComponent } from './Modals/documentProcessingExceptionModal.component';
import { DuplicateIntakeItemModalComponent } from './Modals/duplicateIntakeItemModal.component';
import { IdpAssessmentDetailModalComponent } from './Entity-Edit/IDP/Detail-Modal/idpAssessmentDetailModal.component';
import { FilePreviewComponent } from './Popups/filePreview.component';
import { DocumentProcessingSearchComponent } from './Search/documentProcessingSearch.component';
import {
    DocumentProcessingSearchResultComponent
} from './Search/Quick-Search-Result/documentProcessingSearchResult.component';

@NgModule({
    imports: [
        CommonModule,
        WeissmanSharedModule,
        UILibModule,
        CurrencyPipe,
        AnnualDetailsModule,
        AttachmentModule,
        QuickSearchCriteriaModule,
        ParcelIconModule,
        QuickSearchModule
    ],
    declarations: [
        DocumentProcessingComponent,
        EntityEditComponent,
        EntityPanelComponent,
        FilePreviewComponent,
        IdpConfidenceDetailsComponent,
        IdpBillDetailModalComponent,
        IdpDetailCardComponent,
        DuplicateIntakeItemModalComponent,
        DocumentProcessingExceptionModalComponent,
        IdpAssessmentDetailModalComponent,
        DocumentProcessingSearchComponent,
        DocumentProcessingSearchResultComponent
    ],
    exports: [
        DocumentProcessingComponent,
        IdpConfidenceDetailsComponent,
        DocumentProcessingSearchComponent,
        FilePreviewComponent
    ]
})
export class DocumentProcessingModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('processingEntityEdit', EntityEditComponent);
        hybridAdapterUtility.downgradeNg2Component('idpConfidenceDetails', IdpConfidenceDetailsComponent);
        hybridAdapterUtility.downgradeNg2Component('documentProcessing', DocumentProcessingComponent);
    }
}
